module.exports = __webpack_public_path__ + "media/images/log/log-graph-tyugoku-87a7c741dd7b00a2dd8fb39993976224.svg";